import React from "react";
import {
  TableHead,
  TableRow,
  TableCell,
  TableSortLabel,
  Box,
} from "@material-ui/core";
import styled from "styled-components/macro";
import ColumnFilter from "./ColumnFilter";
import { COLUMN_FILTER_CONFIG } from "./meterReadingsHistoryConstants";

const HeaderCell = styled(TableCell)`
  background-color: ${(props) => props.theme.palette.background.default};
  font-weight: 600;
  position: sticky;
  top: 0;
  z-index: 101;
  padding: ${(props) => props.theme.spacing(1)}px;
  font-size: 0.75rem;
  white-space: nowrap;
`;

const MeterReadingsHistoryHeader = ({
  columns,
  orderBy,
  order,
  onSort,
  columnFilters,
  filterOptions,
  onFilterChange,
}) => {
  const createSortHandler = (columnId) => () => {
    onSort(columnId);
  };

  return (
    <TableHead>
      <TableRow>
        {columns.map((col) => {
          const filterConfig = COLUMN_FILTER_CONFIG[col.id];

          return (
            <HeaderCell
              key={col.id}
              align={col.align}
              style={col.minWidth ? { minWidth: col.minWidth } : undefined}
            >
              <Box display="flex" alignItems="center">
                <TableSortLabel
                  active={orderBy === col.id}
                  direction={orderBy === col.id ? order : "asc"}
                  onClick={createSortHandler(col.id)}
                >
                  {col.label}
                </TableSortLabel>
                {filterConfig &&
                  filterOptions[filterConfig.key]?.length > 0 && (
                    <ColumnFilter
                      label={filterConfig.label}
                      options={filterOptions[filterConfig.key]}
                      selectedValues={columnFilters[filterConfig.key] || []}
                      onChange={(values) =>
                        onFilterChange(filterConfig.key, values)
                      }
                    />
                  )}
              </Box>
            </HeaderCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
};

export default MeterReadingsHistoryHeader;
